import {doc, setDoc, Timestamp, increment} from 'firebase/firestore';
import {firestore, getCollectionPath} from '../config/Firebase';
import DateTime from './DateTime';
import Debug from './Debug';
import md5 from 'md5';

export default class FeaturedProductMetric {
    static incrementViewCount(productId, categoryId, mediaType, client, instance) {
        if (!productId || !categoryId || !mediaType || !client || !instance || !instance.id) {
            Debug.printToLog('error', 'incrementViewCount() is missing required data');
            return Promise.resolve();
        }
        const timestamp = Timestamp.now();
        const date = new Date(timestamp.seconds * 1000);
        const dateKey = DateTime.formatDate(date, true, '-', ['year', 'month', 'day']);
        const id = md5(`${instance.id}_${productId}_${categoryId}`);
        const data = {
            instance: instance.id,
            productId: productId,
            categoryId: categoryId,
            client: client,
            mediaType: mediaType,
            views: {
                [dateKey]: increment(1)
            }
        };
        const _path = getCollectionPath(client, 'featured_metrics');
        const _document = doc(firestore, _path, id);
        return setDoc(_document, data, {merge: true})
            .catch((error) => {
                Debug.printToLog('error', error);
            });
    };
}